// extracted by mini-css-extract-plugin
module.exports = {"blackColor":"#000","container":"TextEditor_container__3J__F"};